// John Eldhose 20180618
import { RestfulPost } from './Restful';

export async function updateContact(data, orgi) {
  data['original'] = orgi;
  const cont = await RestfulPost('updateContact', {data: data}, (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return cont;
}



// WEBPACK FOOTER //
// ./src/Api/updateContact.js